import styled, { Scale } from '@secretescapes/falcon';
import { CommonStyledProps } from '@utils/styles.utils';

export const Container = styled('div')<CommonStyledProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: end;
  gap: ${({ isMobile }) => (isMobile ? Scale.xs : Scale.l)};
`;

export const TYLogoContainer = styled('div')<CommonStyledProps>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ isMobile }) => (isMobile ? Scale.xs : Scale.xxs)};
`;
